/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateSubbrandLookupDto
 */
export interface UpdateSubbrandLookupDto {
    /**
     * Unique sub-brand code
     * @type {string}
     * @memberof UpdateSubbrandLookupDto
     */
    code?: string;
    /**
     * Sub-brand name in English
     * @type {string}
     * @memberof UpdateSubbrandLookupDto
     */
    nameEn?: string;
    /**
     * Arabic name of the sub-brand
     * @type {string}
     * @memberof UpdateSubbrandLookupDto
     */
    nameAr?: string;
    /**
     * Whether the sub-brand is active
     * @type {boolean}
     * @memberof UpdateSubbrandLookupDto
     */
    isActive?: boolean;
    /**
     * Sort order for display
     * @type {number}
     * @memberof UpdateSubbrandLookupDto
     */
    sortOrder?: number;
    /**
     * Parent brand lookup ID
     * @type {number}
     * @memberof UpdateSubbrandLookupDto
     */
    brandLookupId?: number;
}

/**
 * Check if a given object implements the UpdateSubbrandLookupDto interface.
 */
export function instanceOfUpdateSubbrandLookupDto(value: object): value is UpdateSubbrandLookupDto {
    return true;
}

export function UpdateSubbrandLookupDtoFromJSON(json: any): UpdateSubbrandLookupDto {
    return UpdateSubbrandLookupDtoFromJSONTyped(json, false);
}

export function UpdateSubbrandLookupDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateSubbrandLookupDto {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'nameEn': json['nameEn'] == null ? undefined : json['nameEn'],
        'nameAr': json['nameAr'] == null ? undefined : json['nameAr'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'sortOrder': json['sortOrder'] == null ? undefined : json['sortOrder'],
        'brandLookupId': json['brandLookupId'] == null ? undefined : json['brandLookupId'],
    };
}

export function UpdateSubbrandLookupDtoToJSON(value?: UpdateSubbrandLookupDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'code': value['code'],
        'nameEn': value['nameEn'],
        'nameAr': value['nameAr'],
        'isActive': value['isActive'],
        'sortOrder': value['sortOrder'],
        'brandLookupId': value['brandLookupId'],
    };
}

